import { apiClient, StatusEnum } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";
import { useCallback } from "react";

export const BankSelect = (props) => {
  const fetchBanks = useCallback(async () => {
    const {
      data: { data },
    } = await apiClient.get("banks", {
      params: {
        status: StatusEnum.ACTIVE,
      },
    });
    return data;
  }, []);

  return (
    <CustomAutocomplete
      fetchOptions={fetchBanks}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
    />
  );
};
